/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '-36 38 26 26',
    data: `<g class="st0"><path pid="0" class="st1" d="M-11.6 63.4c-.3 0-.5-.1-.7-.3l-11-11-11 11c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l11-11-11-11c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l11 11 11-11c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-11 11 11 11c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3z"/></g>`
  }
})




// WEBPACK FOOTER //
// ./src/icons/close.js